import { Button } from '#/components/ui/button';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router';

import { buttonStyles } from '../styles/button';
import { pageTitleStyles } from '../styles/page-title';
import type { Route } from './+types/login';

// 遷移元ページごとのメッセージ設定
const getLoginMessage = (fromPath: string): { title: ReactNode; message: ReactNode } => {
  if (fromPath.startsWith('/mypage/point-history')) {
    return {
      title: 'カブ活履歴',
      message: 'カブ活履歴はログイン後利用できます。',
    };
  }
  if (fromPath.startsWith('/mypage/action-history')) {
    return {
      title: 'カブ活履歴',
      message: 'カブ活履歴はログイン後利用できます。',
    };
  }
  if (fromPath.startsWith('/mypage/click-history')) {
    return {
      title: 'カブ活履歴',
      message: 'カブ活履歴はログイン後利用できます。',
    };
  }
  if (fromPath.startsWith('/favorite')) {
    return {
      title: 'お気に入り',
      message: 'お気に入りはログイン後利用できます。',
    };
  }
  if (fromPath.startsWith('/campaign/transfer')) {
    // 通常、このページに未ログイン状態で到達することはないが、直接アクセスされた場合に備えて用意しておく
    return {
      title: 'キャンペーンに応募するには',
      message: 'キャンペーンへの応募にはログインが必要です。',
    };
  }
  if (fromPath.startsWith('/contact')) {
    return {
      title: (
        <>
          KABU&カブ活
          <br />
          お問い合わせフォーム
        </>
      ),
      message: 'お問い合わせはログイン後利用できます。',
    };
  }

  // デフォルトメッセージ
  return {
    title: 'ログインが必要です',
    message: 'この機能を利用するにはログインが必要です。',
  };
};

export const loader = async ({ request }: Route.LoaderArgs) => {
  const url = new URL(request.url);
  const redirectPath = url.searchParams.get('redirect') || '/';

  return {
    redirectPath,
  };
};

export default function LoginPage({ loaderData }: Route.ComponentProps) {
  const { redirectPath } = loaderData;
  const navigate = useNavigate();
  const { title, message } = getLoginMessage(redirectPath);

  const handleLogin = () => {
    // 環境変数からログインURLを取得
    const loginUrl = import.meta.env.VITE_LOGIN_URL;

    if (loginUrl) {
      // 外部URLの場合
      if (loginUrl.startsWith('http://') || loginUrl.startsWith('https://')) {
        const url = new URL(loginUrl);
        url.searchParams.set('transitionPath', redirectPath);
        window.location.href = url.toString();
      } else {
        // 内部パス(通常は/dev-login)の場合
        const url = new URL(loginUrl, window.location.origin);
        url.searchParams.set('transition_path', redirectPath);
        navigate(url.pathname + url.search);
      }
    }
  };

  return (
    <div className="main-container-m pt-6 pb-20">
      <div className={pageTitleStyles}>
        <h2>{title}</h2>
      </div>

      <div className="text-body-s md:text-body-m pt-6 pb-14 text-center md:pb-[242px]">
        <p>{message}</p>
      </div>

      <div className="flex justify-center">
        <Button className={buttonStyles.default.lg} onClick={handleLogin}>
          ログインする
        </Button>
      </div>
    </div>
  );
}
